<div *ngIf="appService.editor$ | async" class="model-action" style="display: block; position: absolute;">
  <a *ngIf="!id && action==='CREATE'"  (click)="add.emit()">Add {{ modelType }}</a>
  <ng-container *ngIf="id && action=='UPDATE'">
    <mat-icon svgIcon="mat:edit" (click)="update.emit()" class="icon-sm"></mat-icon> |
    <mat-icon svgIcon="mat:delete" (click)="remove.emit()" class="icon-sm"></mat-icon>
  </ng-container>
</div>
